import { httpClient } from './http-client';
export const getShippingRules = async (data, signal) => httpClient.post('/api/payment/shipping-rules', data, { signal });
